import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import locizeBackend from 'i18next-locize-backend';
import getSharedConfig from './sharedConfig';

const isProduction = process.env.NODE_ENV === 'production';

const locizeOptions = {
  projectId: '0fbd3fca-49fe-4b93-8638-cc57e643a584',
  apiKey: '153e11f2-2ad4-4954-a590-69fed4528934',
  referenceLng: 'en'
};

const XHROptions = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  // path to post missing resources
  addPath: 'locales/add/{{lng}}/{{ns}}',
  allowMultiLoading: false
};

const getI18n = locale =>
  i18n.use(isProduction ? XHR : locizeBackend).init({
    ...getSharedConfig(locale),
    initImmediate: false,
    saveMissing: !isProduction,
    backend: isProduction ? XHROptions : locizeOptions
  });

export default getI18n;
